import gen from '../gen'
import router from '../../../router'
import googleCloudVisionAPI from "./googleCloudVisionAPI";
var ls = require('local-storage');
var dms2dec = require('dms2dec');
var geo = require('geo-hash')
import auth from '@/store/modules/auth/auth'
import common from '@/store/modules/common/common'
import configurations from '../../../configurations'

import {_index_mon, _index_dur} from '../../../helper/dateTimeOrgIndex'

const state = {
  imageUploadingToStorage: false
}

const getters = {
  imageUploadingToStorage: state => state.imageUploadingToStorage
}

const mutations = {
  //
  uploadImage_1(state) {
    // console.log(`upload, attach event listener...`)
    //
    document.getElementById("upload").addEventListener("click", function () {
      // console.log(`auth`, auth)
      var myUploadWidget = cloudinary.createUploadWidget(
        {
        cloudName: configurations.cloudinary_cloudName,
        uploadPreset: "1920px",
        imageMetadata: true,
        theme: 'minimal',
        multiple: false,
        showPoweredBy: false,
        tags: ['UNLINKED PHOTO'],
        inlineContainer: "#inline_container",
        language: "en",
        styles: {
          palette: {
            window: "#ffffff",
            sourceBg: "#FFFFFF",
            windowBorder: "#FFFFFF",
            tabIcon: "#FFFFFF",
            inactiveTabIcon: "#FFFFFF",
            menuIcons: "#FFFFFF",
            link: "#56e3c2",
            action: "#56e3c2",
            inProgress: "#56e3c2",
            complete: "#339933",
            error: "#cc0000",
            textDark: "#ffffff",
            textLight: "#fcfffd"
          }
        },
        text: {
          "en": {
            "local": {
              "browse": "Select Image",
              "dd_title_single": "Drag and Drop an asset here",
              "dd_title_multi": "Drag and Drop assets here",
              "drop_title_single": "Drop a file to upload",
              "drop_title_multiple": "Drop files to upload"
            },
            "menu": {
              "files": "Upload a photo"
            }
          }
        },
        sources: ['local']
      }, (error, result) => {
        console.log("RESuLT", result)
        if (result.event === "success") {
          gen.state.opencw = false
          document.getElementById('inline_container').innerHTML = ''
          //

          //save img link to db
          //
          // console.log(result[0])
          let picDetail = result.info
          //
          let url = picDetail.url //main pic url
          // console.log("[url] ", url)
          //
          let thumbnailImgUrl = picDetail.thumbnail_url
          // console.log("[thumbnail image url]", thumbnailImgUrl)
          //
          let resourceType = picDetail.resource_type
          // console.log("[resourceType] ", resourceType)
          //
          let publicId = picDetail.public_id
          // console.log("[publicId]", publicId)
          //
          ls.set('thumbnailImgUrl', thumbnailImgUrl);
          //
          /******************* METADATA *******************/
          //
          let metaData = picDetail.image_metadata
          // console.log("[metaData]", metaData)
          // try to get mon & dur
          let dateTimeOriginal
          let _mon
          let _mon2
          let _dur
          let _dur2
          if (metaData.DateTimeOriginal != undefined) {
            dateTimeOriginal = metaData.DateTimeOriginal
            // console.log({dateTimeOriginal})
            _mon = dateTimeOriginal[5] + dateTimeOriginal[6]
            // console.log({_mon})
            _mon2 = _index_mon(_mon)
            // console.log({_mon2}) // 1st var
            _dur = parseInt(dateTimeOriginal[11] + dateTimeOriginal[12])
            // console.log({_dur})
            _dur2 = _index_dur(_dur)
            // console.log({_dur2}) // 2nd var
          }
          else {
            _mon2 = 'unknown'
            _dur2 = 'unknown'
          }

          // / try to get mon & dur ends
          let createdAt
          let isOriginalDateNTime = false
          //
          // *** TIMESTAMP ***
          if (Object.keys(metaData).indexOf('DateTimeOriginal') != -1) { //if date exists in metadata
            isOriginalDateNTime = true
            //
            // console.log("1", metaData.DateTimeOriginal)
            createdAt = metaData.DateTimeOriginal
            //
            let createdAt_date = createdAt.substring(0, 10)
            // console.log("2", createdAt_date)
            let createdAt_time = createdAt.substring(11, 19)
            // console.log("3", createdAt_time)
            //
            createdAt_date = createdAt_date.split(':').join('-')
            // console.log("4", createdAt_date)
            //
            createdAt = '' //empty
            createdAt = createdAt_date + 'T' + createdAt_time + 'Z' //2017-12-21T18:14:58Z //format
            //
            // console.log("5", createdAt)
          } else { //date doesnot exists in metadata
            // console.log("created time", result.created_at)
            createdAt = ""
            // console.log("6", createdAt)
          }
          //
          createdAt = createdAt.substring(0, 16) //2017-12-21T18:14 //format
          //
          // *** TIMESTAMP ENDS ***
          //
          // *** LOCATION ***
          let geohash = ''
          let geoLocIsAvailable = false
          //
          if (Object.keys(metaData).indexOf('GPSLatitude') != -1 &&
            Object.keys(metaData).indexOf('GPSLongitude') != -1) {
            let geoLoc_lat = metaData.GPSLatitude
            let geoLoc_lng = metaData.GPSLongitude
            //
            // console.log("[geoLoc_lat]", geoLoc_lat)
            // console.log("[geoLoc_lng]", geoLoc_lng)
            //
            let degMinHr_lat_arr = geoLoc_lat.split(" ") //Hr => sec
            //
            let deg_lat = degMinHr_lat_arr[0]
            let min_lat = degMinHr_lat_arr[2]
            let hr_lat = degMinHr_lat_arr[3]
            let dir_lat = degMinHr_lat_arr[4]
            //
            min_lat = min_lat.replace("'", "")
            hr_lat = hr_lat.replace('"', "")
            //
            //
            let degMinHr_lng_arr = geoLoc_lng.split(" ")
            let deg_lng = degMinHr_lng_arr[0]
            let min_lng = degMinHr_lng_arr[2]
            let hr_lng = degMinHr_lng_arr[3]
            let dir_lng = degMinHr_lng_arr[4]
            //
            min_lng = min_lng.replace("'", "")
            hr_lng = hr_lng.replace('"', "")
            //
            // console.log("1 => " + deg_lat + " | " + min_lat + " | " + hr_lng + " | " + dir_lat)
            // console.log("2 ==> " + deg_lng + " | " + min_lng + " | " + hr_lat + " | " + dir_lng)
            //
            let parse_lat_para_1 = []
            let parse_lat_para_2 = ''
            //
            let parse_lng_para_1 = []
            let parse_lng_para_2 = ''
            //
            parse_lat_para_1.push(Number(deg_lat))
            parse_lat_para_1.push(Number(min_lat))
            parse_lat_para_1.push(Number(hr_lat))
            //
            parse_lat_para_2 = dir_lat
            //
            // console.log("1 => ", parse_lat_para_1, parse_lat_para_2)
            //
            parse_lng_para_1.push(Number(deg_lng))
            parse_lng_para_1.push(Number(min_lng))
            parse_lng_para_1.push(Number(hr_lng))
            //
            parse_lng_para_2 = dir_lng
            //
            // console.log("2 => ", parse_lng_para_1, parse_lng_para_2)
            //
            var dec = dms2dec(parse_lat_para_1, parse_lat_para_2, parse_lng_para_1, parse_lng_para_2)
            // console.log("[DEC]", dec)
            //
            geohash = geo.encode(dec[0], dec[1]);
            //
            geoLocIsAvailable = true
            //
          } else {
            //do nothing
          }

          let photoSourceLink = ""
          // *** LOCATION ENDS ***
          //
          /****************  METADATA ENDS ****************/
          router.push({
            path: '/uploadImage_2',
            query: {
              url,
              resourceType,
              publicId,
              //
              createdAt,
              isOriginalDateNTime,
              //
              geoLocIsAvailable,
              geohash,
              _mon2,
              _dur2,
              photoSourceLink
            }
          })
          common.state.isbottomMenuOpen = false
          //Step 2.4:  Call the .close() method in order to close the widget
          myUploadWidget.close();
        }
      });
      if (auth.state.isLoggedIn) {
        // console.log(`Logged In: Opening Widget.`)
        gen.state.opencw = true
        myUploadWidget.open()
      }
      else {
        console.log(`User not logged in, redirecting to Login Page.`)
        router.push({
          path: `/login`
        })
        common.state.isbottomMenuOpen = false
      }
    }, false);
  }
}

const actions = {

}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/uploadImage/uploadImage_1.js